import Vue from 'vue'
import Util from '@/assets/libs/util'

const eventModule = new Vue()

const waitForDOMUpdate = async () => {
    if (Util.isAndroidMode()) {
        // Usa $nextTick para garantir que o DOM seja atualizado
        await new Promise(resolve => {
            eventModule.$nextTick(() => {
                requestAnimationFrame(resolve)
            })
        })
    }
}

export default {
    waitForDOMUpdate
}



// WEBPACK FOOTER //
// ./src/assets/libs/waitForDOMUpdate.js